module.exports = __webpack_public_path__ + "static/media/logo2.3b092d2d.png";